/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { getChannelList } from '@/api/apply-product';
import { ApplyChannelData } from '@/api/apply-product/types';
import { Component, Prop, Vue } from 'vue-property-decorator';

const NewChangeChannel = () => import(
  /* webpackChunkName: "new-change-channel" */'./component/new-change-channel'
) as any;
const OldChangeChannel = () => import(
  /* webpackChunkName: "old-change-channel" */'./component/old-change-channel'
) as any;

@Component({ name: 'ChangeChannelList' })
export default class ChangeChannelList extends Vue {
  @Prop(String)
  private commodityId!: string;

  // 是否展示新版本
  @Prop(Boolean) readonly isNewChannel!: boolean;

  private channelList: ApplyChannelData[] = [];

  private created() {
    this.getChannelList();
  }

  // 获取可提现渠道
  private async getChannelList() {
    const {
      productCreditResultList,
      gray,
    } = await getChannelList();

    if (gray === 1) {
      this.channelList = productCreditResultList.filter(
        (item) => String(item.productId) !== String(this.commodityId) && item.disabled !== 0,
      );
    } else {
      this.channelList = productCreditResultList.filter(
        (item: ApplyChannelData) => String(item.productId) !== String(this.commodityId),
      );
    }
    this.$emit('showChannel', this.channelList.length > 0);
  }

  private onChannelClick(channel: ApplyChannelData) {
    this.$emit('reApply', channel);
  }

  private render() {
    return (
      this.channelList.length > 0 && (
        this.isNewChannel ? <NewChangeChannel
          channelList={this.channelList}
          onReApply={this.onChannelClick.bind(this)}
        /> : <OldChangeChannel
          channelList={this.channelList}
          onReApply={this.onChannelClick.bind(this)}
        />
      )
    );
  }
}
